import React from 'react';

import { Box } from '@mui/material';

import { FullscreenLoader } from 'src/components/common';
import { RevenueShareCard } from 'src/components/revenueShare';
import { useCurrentUserPeo } from 'src/hooks/peo';
import { NotFoundErrorPage } from 'src/pages/not-found';
import { peoReceivesOwnRevenueShare } from 'src/utils/revenueShare';

export const PeoWallet: React.FC = () => {
  const { peo, loading } = useCurrentUserPeo();

  if (loading) {
    return <FullscreenLoader />;
  }

  if (!peo?.revenueShareSetting || !peoReceivesOwnRevenueShare(peo)) {
    return <NotFoundErrorPage />;
  }

  return (
    <Box width="50%">
      <RevenueShareCard company={peo} />
    </Box>
  );
};
